import { inject, Service } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { downloadFile } from '@shared/utils';
import { ToastService } from './toast.service';

@Service()
export class DownloadService {
  toastService = inject(ToastService);
  translate = inject(TranslateService);

  notifyPreparing = () => {
    this.toastService.show({
      text: this.translate.instant('WEB_NOTIFY_DOWNLOAD_PREPARING'),
      type: 'info',
    });
  };

  downloadGenerated = (url: string, filename?: string) => {
    this.notifyPreparing();
    downloadFile(url, filename);
  };
}
